import axiosInstance from './api_helper';

const BASE_URL = '/api/settings/system';

export const getSystemSettings = () => axiosInstance.get(BASE_URL);

export const updateSystemSettings = (settings) =>
  axiosInstance.put(BASE_URL, settings);
